export const environment = {
  production: false,
  providerId: 12,
  samlApp: 'one',
  downloadBucket: 'sf-db-export-qa',
  appConfig: {
    environment: 'QA',
    useLiveReload: false,
    useLocalHost: false,
    useExternalLocalHost: true,
    externalHostAddr: 'https://api-qa.huddy.io'
  },
};
